import instance from '../config/axios';
import { Product } from '../interface/interface';

export const getPromotionalProducts = async (): Promise<Product[] | number> => {
  try {
    const response = await instance({
      url: '/api/v1/products/featured-products',
      method: 'GET',
    });

    return response.data;
  } catch (error: any) {
    return error?.response?.status ?? 500;
  }
};
